import {GtinStatuses} from 'types/gtins';

export type GtinActionPermissions = {
    canApprove: boolean;
    canBlock: boolean;
    canDelete: boolean;
    canEdit: boolean;
    canPublish: boolean;
    canReportBug: boolean;
    canRecall: boolean;
    canReject: boolean;
    canReleaseNewVersion: boolean;
    canSaveDraft: boolean;
    canUnblock: boolean;
};

export const getGtinActionPermissions = ({
    status,
    isAdmin,
    isAuthor,
    hasEditPermission,
}: {
    status?: GtinStatuses | null;
    isAdmin: boolean;
    isAuthor: boolean;
    hasEditPermission: boolean;
}): GtinActionPermissions => {
    const permissions: GtinActionPermissions = {
        canApprove: false,
        canBlock: false,
        canDelete: false,
        canEdit: false,
        canPublish: false,
        canReportBug: false,
        canRecall: false,
        canReject: false,
        canReleaseNewVersion: false,
        canSaveDraft: false,
        canUnblock: false,
    };
    if (!status) {
        return {
            ...permissions,
            canEdit: hasEditPermission,
            canSaveDraft: hasEditPermission,
        };
    }

    if (isAdmin) {
        // if (status === GtinStatuses.DRAFT) {
        //     permissions.canDelete = true;
        //     permissions.canEdit = true;
        // }

        if (status === GtinStatuses.PENDING) {
            permissions.canApprove = true;
            permissions.canReject = true;
            // permissions.canSaveDraft = true;
        }

        if (status === GtinStatuses.PUBLISHED) {
            permissions.canBlock = true;
        }

        if (status === GtinStatuses.BLOCKED) {
            permissions.canUnblock = true;
        }

        // if (status === GtinStatuses.REJECTED) {
        //     permissions.canDelete = true;
        //     permissions.canEdit = true;
        // }
    }

    if (isAuthor) {
        if (status === GtinStatuses.DRAFT) {
            permissions.canDelete = true;
            permissions.canEdit = true;
            permissions.canPublish = true;
            permissions.canSaveDraft = true;
        }

        if (status === GtinStatuses.PENDING) {
            permissions.canRecall = true;
        }

        if (status === GtinStatuses.REJECTED) {
            permissions.canDelete = true;
            permissions.canEdit = true;
            permissions.canPublish = true;
            permissions.canSaveDraft = true;
        }

        if (status === GtinStatuses.PUBLISHED) {
            permissions.canReleaseNewVersion = true;
        }
    }

    if (permissions.canRecall && permissions.canReject) permissions.canRecall = false;

    return permissions;
};
